import Vue from 'vue'
import store from '@/store'
import VueRouter from 'vue-router'
import Index from '../views/index.vue'
import Detail from '../views/detail.vue'
import Auth from '../views/auth.vue'
import Edit from '../views/edit.vue'
import Login from '../views/login.vue'
import { getToken } from '@/libs/utils'
import config from '@/config'
import { qywxCodeLogin } from '@/api/user'



Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    meta: {
      title: '首页',
      requiresAuth: true,
    },
    component: Index,
  },
  // {
  //   path: '/index',
  //   name: 'index',
  //   meta: {
  //     title: '首页',
  //     isBack: false

  //   },
  //   component: Index,
  // },
  {
    path: '/detail',
    name: 'detail',
    meta: {
      title: 'detail',
      requiresAuth: true,
    },
    component: Detail,
  },
  {
    path: '/edit',
    name: 'edit',
    meta: {
      title: 'edit',
      requiresAuth: true,
    },
    component: Edit,
  },

  {
    path: '/error/:info',
    name: 'Error',
    meta: {
      title: '错误页',
    },
    component: () => import('../views/ErrorPage.vue'),
    props: true,
  },
  {
    path: '/auth',
    name: 'auth',
    component: Auth,
    beforeEnter: async (to, from, next) => {
      // 从URL参数中获取企业微信返回的授权码
      const code = to.query.code
      const state = to.query.state

      if (!code) {
        // 如果没有code参数，跳转到错误页面
        next({
          name: 'Error',
          params: {
            info: "missing_code"
          }
        })
        return
      }

      // 验证state防止CSRF攻击（可选）
      // if (state !== localStorage.getItem('wxwork_state')) {
      //   next({
      //     name:'Error',
      //     params:{
      //       info:"invalid_state"
      //     }
      //   })
      //   return
      // }

      // 将code发送到后端换取用户信息
      

      let data = null
      data = await qywxCodeLogin({ code, state }).catch(err => {
        console.log(err)
        next({
          name: 'Error',
          params: {
            info: "授权登录失败，请确认是否绑定企业微信"
          }
        })
      })
      if (data.data.map.result == 1) {
        store.commit('setToken', data.data.map.token)
        store.commit('setUserInfo', data.data.map.userinfo)
        // 跳转到登录前页面或首页
        const redirect = localStorage.getItem('auth_redirect') || '/'
        next(redirect)
      }
    }
  },

  // 登录页面
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: (to, from, next) => {
      // 检查是否已登录
      if (getToken()) {
        next({ path: '/' })
      } else {
        // 存储重定向路径
        if (to.query.redirect) {
          localStorage.setItem('auth_redirect', to.query.redirect)
        }
        next()
      }
    }
  },

]

const router = new VueRouter({
  routes,
  base: process.env.BASE_URL,
  mode: 'history',
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  const isWhiteListed = config.whiteList.includes(to.path);
  if (isWhiteListed) {
    return next();
  }
  const isAuthenticated = getToken()
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({
        name: 'Login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

// router.beforeEach(async (to, from, next) => {
//   if (to.query.code || to.query.state) {
//     const { code, state } = to.query;
//     console.log(code)
//     console.log(state)

//     store.commit('SET_AUTH_PARAMS', { code, state });

//     console.log(store.state)

//     const cleanQuery = cleanAuthParams(to.query);
//     const cleanPath = Object.keys(cleanQuery).length 
//       ? { path: to.path, query: cleanQuery }
//       : to.path;
//       console.log(cleanPath)

//     return next(cleanPath);
//   }

//   const token = getToken();
//   const authParams = store.state.user.authParams; 
//   const isWhiteListed = config.whiteList.includes(to.path);
//   Toast("token" + token  + '=====authParams' + JSON.stringify(authParams) + '=====isWhiteListed' + isWhiteListed)

//   const redirectUrl = encodeURIComponent(window.location.origin);
//   const openUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.qywx.appId}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base&state=${config.qywx.appId}&agentid=${config.qywx.agentId}#wechat_redirect`  
//   if (isWhiteListed) {

//     return next();
//   }

//   try {
//     if (authParams && !token) {
//       const { code, state } = authParams;
//       await store.dispatch('handleDingDingLogin', { code, state });
//       store.commit('CLEAR_AUTH_PARAMS'); // 清除已用参数
//       return next(); // 继续导航
//     }

//     // 6. 已有token - 验证有效性
//     if (token) {
//       return next(); 
//     }
//     console.log(openUrl)
//     window.location.href = openUrl;
//   } catch (error) {
//     store.commit('CLEAR_AUTH_PARAMS'); // 防止死循环
//     console.error('认证错误:', error);
//     next('/error');
//   }
// })

export default router
